import React from "react";
export default ({ disabled, user }) => (
  <div className="form-row">
    <div className="col-100 col-md-25 d-flex align-items-center">
      <label className="m-0">Gender</label>
    </div>
    <div className="col-100 col-md-75">
      <div className="select">
        <select defaultValue={user.gender} disabled={disabled} className="form-control" name="gender">
          <option value={""}>Select</option>
          <option>Male</option>
          <option>Female</option>
          <option>Non-binary</option>
          <option>Prefer Not to Say</option>
        </select>
      </div>
    </div>
  </div>
);
